import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=6c657fae&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=6c657fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c657fae",
  null
  
)

export default component.exports